<template>
<div class="privacy-wrapper">
    <div class="privacy_policy">
        <h2 style="text-align: center;">智眸隐私政策</h2>
        <div class="date">
            <p>更新时间：2023年5&nbsp;月&nbsp;17日</p>
            <p>生效时间：2023年5&nbsp;月&nbsp;17日</p>
        </div>
        <div class="content">
            <p>
                <span>感谢您选择</span>
                <a> 上海恒生聚源数据服务有限公司 </a>
                <span>
                    （以下简称“我们”）的服务/产品。我们深知个人信息对您的重要性，因此我们将按照法律法规及行业标准的规定及要求采取有效的安全保障措施，力求保障您个人信息的安全可控。
                </span>
            </p>
            <p>
                <span>请您在使用我们的服务/产品前仔细阅读《隐私政策》（对于重点内容我们会以加粗字体的形式予以提示）并做出相应的选择，</span>
                <b>
                    若您使用我们的服务/产品，则表示您认可我们在政策中所表述的内容，同意我们按照本隐私政策处理您的个人信息。我们收集和使用您信息的目的、方式和范围将通过相应的产品（或服务）协议、授权书方式向您明示，并取得您的授权或同意。产品协议与本《隐私政策》共同构成我司与您之间达成的完整隐私政策，两者如有不一致之处，以相应产品协议的约定为准。
                </b>
            </p>
            <p>
                <span>本隐私政策适用于您通过 </span>
                <a> 智眸 </a>
                <span> 应用程序、供第三方网站和应用程序使用的 </span>
                <a> 智眸 </a>
                <span>软件开发工具包（SDK）和应用程序编程接口（API）方式来访问和使用我们的产品和服务。</span>
            </p>
            <h2>您将通过本政策了解到以下内容：</h2>
            <div style="text-align:left">
                <div>1、我们如何收集您的个人信息；</div>
                <div>2、我们如何使用您的个人信息；</div>
                <div>3、我们如何存储个人信息；</div>
                <div>4、我们如何使用Cookie 和同类技术；</div>
                <div>5、我们如何共享、转让、公开披露您的个人信息；</div>
                <div>6、我们如何保护您的个人信息；</div>
                <div>7、您对个人信息的管理；</div>
                <div>8、未成年人个人信息保护；</div>
                <div>9、隐私政策的适用及更新；</div>
                <div>10、如何联系我们。</div>
            </div>
            <div>
                <p><b>1、我们如何收集您的个人信息</b></p>
                <p>
                    我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。
                </p>
                <p>
                    当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。
                </p>
                <p>
                    出于本政策以下目的，为实现我们服务/产品的功能，我们会遵循合法、正当、必要的原则，收集您的个人信息，帮助您成为我们的用户，以期您能够获得良好的服务体验。
                </p>
                <b>
                    请注意，无法与任何特定个人直接建立联系的数据（如单独的设备信息、日志信息等），不属于个人信息。如果我们将无法与任何特定个人建立联系的数据与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
                </b>
            </div>
            <div>
                <p>1.1 基本业务功能</p>
                <p>
                    1.1.1用户注册：在您注册成为我们的用户时，我们需要您提供<b>手机号、登录密码</b>以创建账号。<b>头像、昵称、名片、性别、生日</b>为非必要信息，自愿填写后我们为您提供定制化的产品服务。
                </p>
                <p>
                    1.1.2 账号管理：我们为您提供账号查询、更正、删除、退出功能。在该项业务功能中，您需向我们提供以下信息，包括：<b>昵称、头像。</b>其中，当您更改您的头像信息时，需要您授权开启相机权限、读取本地存储权限、写入本地存储权限，以便更好的为您提供拍照或相册选取照片的相关服务。如您拒绝授予相机权限、读取本地存储权限，则仅影响当前头像更换功能，不影响您正常使用其他业务功能。
                </p>
                <p>
                    1.1.3 关注资讯功能：我们为您提供关注企业的资讯服务，需要您提供<b>位置信息、我的关注</b>企业权限，以便更好的为您提供关注资讯的相关服务。如您拒绝授予收藏列表、位置信息权限、我的关注企业权限，不影响您正常使用其他业务功能。
                </p>
                <p>
                    1.1.4 查企业功能：我们为您提供查企业功能
                </p>
                <p>
                    1.1.5 日志分析： 我们需要记录您在使用我们产品过程中产生的日志信息，日志中将会收集您的<b>使用日期</b>和<b>时间</b>,以及<b>手机设备信息（您的硬件型号、操作系统版本、使用语言、设备配置、唯一设备标识符、IMEI、MAC地址、IP地址、IMEI、UDID）。</b>我们会对日志信息进行分析，用于客户服务、改善产品功能、提升用户体验。 如您拒绝提供上述信息，不影响您正常使用其他业务功能。需要您开启读取电话状态权限，如您拒绝授予读取电话状态权限，您将无法正常使用APP内唤起电话拨打功能。
                </p>
            </div>
            <div>
                <p>1.2 非基础业务功能：</p>
                <p>
                    1.2.1当您通过APP内“我要提意见”功能入口提交意见时，我们将启用相机权限、读取本地存储权限。若您拒绝我们收集上述个人信息，将无法使用我们提供的非基本业务功能以及第三方提供的业务功能，但是不会影响您使用智眸的基本业务功能。
                </p>
            </div>
            <div>
                <b>2、我们如何使用您的个人信息</b>
                <p>
                    我们会严格遵守法律法规的规定使用您的个人信息，您的个人信息将被用到以下用途：
                </p>
                <p>2.1 向用户提供我们的各项服务及客户服务，并维护、改进这些服务。</p>
                <p>
                    2.2 为您提供安全保障，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务用途，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接。
                </p>
                <p>
                    2.3 改进我们的服务/产品，我们会在符合法律规定并根据您具体授权的情况下收集并使用您的个人信息用于统计分析，以此改进我们的服务/产品。
                </p>
                <p>
                    2.4 其他用途，我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
                </p>
                <p>2.5 例外情形</p>
                <p>出现下列情形我们无需征得您的授权同意，请您悉知。</p>
                <p>2.5.1 与国家安全、国防安全有关的；</p>
                <p>2.5.2 与公共安全、公共卫生、重大公共利益有关的；</p>
                <p>2.5.3 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
                <p>2.5.4 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
                <p>2.6.5 所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
                <p>2.6.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
                <p>2.5.7 根据您的要求签订合同所必需的；</p>
                <p>2.5.8 用于维护所提供的服务/产品的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
                <p>2.5.9 为合法的新闻报道所必需的；</p>
                <p>2.5.10 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
                <p>2.5.11 法律法规规定的其他情形。</p>
            </div>
            <div>
                <p class="chapter"><b>3、我们如何存储个人信息</b></p>
                <p>3.1 存储地点</p>
                <p>我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，
                    <b>
                        如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。
                    </b>
                </p>
                <p>3.2 存储期限</p>
                <p>
                    我们仅在为提供产品/服务之目的所必需的期间内保留您的个人信息。在您未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
                </p>
                <p>
                    如我们停止我们的服务/产品时，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
                </p>
            </div>
            <div>
                <p class="chapter"><b>4、我们如何使用Cookie 和同类技术</b></p>
                <p>4.1 Cookie</p>
                <p>为确保网站正常高效运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储相关信息：这些信息可能是Cookie或您的浏览器或关联应用程序提供的其他本地存储。像大多数标准网站服务器一样，我们使用cookie技术生成日志文件以收集必要信息（包含
                    <b>访问者的IP地址、日期和时间以及浏览的页面</b>）来分析趋势，管理站点，跟踪用户的总体使用。Cookie会帮助您在后续访问我们网站时调用您的信息，简化一键登录的流程;保护您的数据安全。 我们不会将 Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie，但拒绝我们的Cookie在某些情况下可能会影响您安全访问网站和使用我们提供的服务。日志中IP地址信息与个人身份信息无关。
                </p>
                <p>4.2 同类技术</p>
                <p>除Cookie外，我们还会在网站上使用网站信标和像素标签其他同类技术。它们可以帮助网站计算浏览网页的用户或访问某些Cookie。</p>
            </div>
            <div>
                <p class="chapter"><b>5、我们如何共享、转让、公开披露您的个人信息；</b></p>
                <p>5.1 共享</p>
                <p>5.1.1我们会严格遵照法律法规的规定使用您的个人信息，非因法定或者约定情形，我们不会与第三方共享您的个人信息。</p>
                <p>
                    <b>5.1.2我们将您的手机号码共享给您同意的第三方，以便第三方可以更好地为您提供服务。上述共享的行为我们将在您明示同意且知悉该具体第三方的情况下进行。但是，若共享的信息无法与任何特定个人直接建立联系的除外。</b>
                </p>
                <p><b>5.1.3我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</b></p>
                <p>我们接入的相关第三方开发包（SDK）、应用程序接口（API）的目录如下：</p>
                <table>
                   <tr>
                        <td>第三方SDK名称</td>
                        <td>共享的目的</td>
                        <td>个人信息字段</td>
                        <td>传输方式</td>
                        <td>信息共享方式</td>
                   </tr>
                    <tr>
                        <td>com.tencent.smtt(TBS;腾讯浏览器;腾讯X5浏览器)com.android.dingtalk(钉钉)</td>
                        <td>分享到微信功能</td>
                        <td>分享信息、
                            SDK自发的后台定位、
                            获取系统安装应用列表</td>
                        <td>数据去标识化传输</td>
                        <td>自动收集</td>
                    </tr>
                    <tr>
                        <td>cn.jiguang cn.jpush com.heytap.msp(OPPO;OPush)com.xiaomi.push(小米;小米推送)</td>
                        <td>通过识别设备信息为App赋予推送能力，用于消息推送；地理位置和网络信息用于创建智能标签，实现区域、分群推送功能</td>
                        <td>个人常用设备信息、
                            位置信息、
                            网络信息、
                            系统安装应用列表</td>
                        <td>采用去标识化化方式对个人信息进行脱敏展示</td>
                        <td>调用系统相关接口自动采集</td>
                    </tr>
                    <tr>
                        <td>com.umeng.umsdk</td>
                        <td>数据统计分析</td>
                        <td>Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供</td>
                        <td>采用去标识化化方式对个人信息进行脱敏展示</td>
                        <td>自动收集</td>
                    </tr>
                </table>
                <p>5.2 转让</p>
                <p>我们会严格遵照法律法规的规定使用您的个人信息，非因法定或者约定情形我们不会向第三方转让您的个人信息，但以下情形除外：</p>
                <p>5.2.1在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
                <p>5.2.2 业务转让：在我们及我们的关联方之间发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告形式告知您相关情形，我们会要求受让您个人信息的公司、组织继续接受本隐私政策的约束，否则,我们将要求该公司、组织重新征求您的授权同意。</p>
                <p>5.3 信息公开披露</p>
                <p>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才公开披露您的个人信息：</p>
                <p>5.3.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
                <p>5.3.2 根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。</p>
                <p>5.4共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
                <p>请您悉知，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
                <p>5.4.1与国家安全、国防安全有关的；</p>
                <p>5.4.2与公共安全、公共卫生、重大公共利益有关的；</p>
                <p>5.4.3与犯罪侦查、起诉、审判和判决执行等有关的；</p>
                <p>5.4.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
                <p>5.4.5其他维护公共利益的情形，例如您的信用评价信息需要被公开\共享；</p>
                <p>5.4.6您自行向社会公众公开的个人信息；</p>
                <p>5.4.7从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
            </div>
            <div>
                <p class="chapter"><b>6、我们如何保护您的个人信息</b></p>
                <p>6.1 我们会采取合理的预防措施以保护通过本网站收集、使用的个人识别信息的安全。除技术保护之外，我们同时也使用物理控制和程序保护用户的识别信息。</p>
                <p>6.2 完善的信息安全管理制度，我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。</p>
                <p>6.3请您知悉并理解，<b>互联网并非绝对安全的环境</b>，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账号或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。</p>
                <p>6.4我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可以通过我们公布的官方网站获取相关信息。</p>
                <p>6.5如不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
            </div>
            <div>
                <p class="chapter"><b>7、您对个人信息的管理</b></p>
                <p>7.1 个人信息管理编辑。</p>
                <p>您可以通过以下方式实现：您可以通过点击【我的】-【左上角头像】-【个人信息】、更正您账号中的个人资料及账号信息（身份认证信息除外），您可以通过致电400-820-7887重新绑定手机、重置登录密码。</p>
                <p>7.2 授权更改或撤回设置。</p>
                <p>您可以在设备本身操作系统中关闭GPS地理位置、摄像头、相册权限更改同意范围或撤回您的授权。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理。</p>
                <p>7.3个人信息删除。</p>
                <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
                <p>7.3.1如果我们处理个人信息的行为违反法律法规；</p>
                <p>7.3.2如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
                <p>7.3.3如果我们处理个人信息的行为严重违反了与您的约定；</p>
                <p>7.3.4如果您不再使用我们的产品或服务，或您主动注销了账号；</p>
                <p>7.3.5如果我们永久不再为您提供产品或服务。</p>
                <p>个人信息删除请通过400-820-7887联系我们(我们将在15个工作日内处理)，若我们决定响应您的删除请求，我们还将同时通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。当您从我们的服务中删除信息后，我们不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
                <p>7.4注销账号。</p>
                <p>如您需要注销账号，请使用该账号所绑定的手机号致电400-820-7887。我们将在2个工作日内处理。在您注销帐号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销帐号的行为是不可逆的行为，当您注销帐号后，我们将根据适用的法律法规的要求尽快使其匿名或删除您的个人信息，但法律法规做出例外规定，我们会严格按照要求执行。</p>
            </div>
            <div>
                <p class="chapter"><b>8、未成年人个人信息保护</b></p>
                <p>
                    我们非常重视对未成年人个人信息的保护。您是18周岁以下的未成年人，不能够创建自己的用户账号或应事先取得您的家长或法定监护人的同意前提下使用我们的服务或向我们提供信息。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过我们提供的联系方式联系我们。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
                </p>
            </div>
            <div>
                <p class="chapter"><b>9、隐私政策的适用及更新</b></p>
                <p>9.1隐私政策的适用，如果我们没有特别说明，本隐私政策适用于我们全部的服务/产品。如我们发布的特定隐私政策与本政策存在不一致时，请以特定隐私政策为准。</p>
                <p>9.2 隐私政策的更新，根据我们提供服务/产品的更新情况，我们适时调整隐私政策，但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</p>
            </div>
            <div>
                <p class="chapter"><b>10、如何联系我们</b></p>
                <p>
                    如果您对本隐私政策有疑问或者投诉举报请通过400-820-7887     
                    联系方式联系我们(我们将在15个工作日内处理)。我们的联系地址为上海市浦东新区峨山路91弄陆家嘴软件园10号楼7层。
                </p>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default{
    mounted(){
        document.title = "隐私政策"
    }
}
</script>
<style lang="less" scoped>
body {
  margin: 0;
}
.privacy-wrapper {
  box-sizing: border-box;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: 100% auto;
  padding: 10px;
}
h1 {
  margin-top: 90px;
  color: #ffffff;
  font-size: 20px;
  line-height: 28px;
  margin-left: 21px;
}
.privacy-main {
  color: #30303d;
  font-size: 13px;
  margin: 92px 20px 0;
}
.privacy_title {
  font-size: 18px;
  line-height: 25px;
  font-weight: 600;
  text-align: left;
}
.paragraph {
  font-size: 13px;
  line-height: 18px;
  text-align: justify;
  margin-top: 20px;
}
.blue {
  color: #3258de;
}
.privacy_foot {
  width: 100%;
  margin: 34px auto 0;
  font-size: 0px;
  text-align: left;
}
.user_agreement,
.privacy_policy {
  font-size: 14px;
  color: #303133;
}
.user_agreement p,
.privacy_policy p {
  line-height: 20px;
  text-align: justify;
  margin-bottom: 20px;
}
p.chapter {
  font-weight: bold;
}
.user_agreement h2,
.privacy_policy h2 {
  font-size: 20px;
  font-weight: bold;
  margin: 15px 0;
  text-align: left;
  color: #303133;
}
table {
  border-top:1px solid #303133;
  border-left:1px solid #303133;
  border-collapse: collapse;
  padding: 0;
  width:100%;
  table-layout: fixed;
}
table td {
  width:20%;
  word-wrap:break-word;
  border-bottom: 1px solid #303133;
  border-right:1px solid #303133;
}
</style>

